export default "__VITE_ASSET__DCGz$I0L__"